// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { CloudRunPathBuilder, Env, IPlatformAdminEnvironment, ServiceNames } from 'shared-lib'

const env: Env = 'dev'
//const pathBuilder = new AppEnginePathBuilder(env)

const singleBackendServices: ServiceNames[] = []
const pathBuilder = new CloudRunPathBuilder('dr32hxly6a', 'https', singleBackendServices)

export const environment: IPlatformAdminEnvironment = {
  production: false,
  env,
  singleBackendServices,
  firebaseConfig: {
    apiKey: 'AIzaSyCnP-U4Q9cCTJ6jCB5aAfdNdPm66Owq6_4',
    authDomain: 'cnect-dev.firebaseapp.com',
    databaseURL: 'https://cnect-dev.firebaseio.com',
    projectId: 'cnect-dev',
    storageBucket: 'dev-content.cnected.com',
    messagingSenderId: '114692117909',
    appId: '1:114692117909:web:87fb5f0d7cf941a774129c',
    measurementId: 'G-YZQ6CP83FZ',
  },

  services: {
    jobs: pathBuilder.build('jobs'),
    jobsAutomation: pathBuilder.build('jobs-automation'),
    registration: pathBuilder.build('registration'),
    user: pathBuilder.build('user'),
    auth: pathBuilder.build('auth'),
    files: pathBuilder.build('files'),
    customer: pathBuilder.build('customer'),
    notifications: pathBuilder.build('notifications'),
    product: pathBuilder.build('product'),
    reporting: pathBuilder.build('reporting'),
    crm: pathBuilder.build('crm'),
    platformAdmin: pathBuilder.build('platformAdmin'),
  },

  // We can turn authentication off in case we are using this application inside and SDK and do not want to have any authentication
  authentication: true, // Look to the auth guard for use of this value
  themesEnabled: true,
  v2ReCaptcha: '6LcVas0aAAAAAAcHaLi9835I5X1EPovMGnsTVm_Z',
  tenantId: 'PLATFORM-USER-n81ik',
  algoliaAppId: 'SH1DAV8W6D',
  cdnCname: 'dev-content.cnected.com',
  version: '609de00',
  basePlatformHost: 'dev-admin.cnect.jobs',
  actAsAllowedHosts: '\\.(cnected\\.com|cnected\\.app|cnect\\.jobs|cnect\\.com|cnect\\.dev)$',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
